import { useTranslation } from "react-i18next";
import { formatMonitoringTakenLine } from "../collection/monitoringRowUtils";
import { formatAnomalyNotificationDescription } from "./notificationDisplayUtils";
import NotificationSiteMetaLine from "./NotificationSiteMetaLine";
import {
  getNotificationTypeLabel,
  shouldShowNotificationDescription,
} from "./notificationTypeUtils";

const NotificationDetailSummary = ({
  type,
  description,
  wasteName,
  addressName,
  date,
}) => {
  const { t } = useTranslation();
  const typeLabel = getNotificationTypeLabel(type, t);
  const formattedDescription =
    formatAnomalyNotificationDescription(description);
  const showDescription = shouldShowNotificationDescription(
    type,
    formattedDescription,
    typeLabel,
  );
  const takenLine = date ? formatMonitoringTakenLine({ time: date, t }) : "";

  return (
    <div className="notification-detail-summary">
      {showDescription && (
        <p className="notification-detail-summary-description">
          {formattedDescription}
        </p>
      )}
      <NotificationSiteMetaLine
        wasteName={wasteName}
        addressName={addressName}
      />
      {takenLine && (
        <p className="notification-detail-summary-date">{takenLine}</p>
      )}
    </div>
  );
};

export default NotificationDetailSummary;
